/**
 * Codmonサイドメニュータイトルディレクティブ
 *
 * @description
 * このディレクティブは、サイドメニュー内でセクションのタイトルを表示するコンポーネントを提供します。
 * アイコンと組み合わせてセクションの見出しとして使用します。
 *
 * @example
 * // 基本的な使用方法
 * <codmon-sidemenu-title>
 *   設定
 * </codmon-sidemenu-title>
 */
angular.module('inspinia').directive('codmonSidemenuTitle', () => {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {},
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_sidemenu_title.html?${new Date().getTime()}`,
  };
});
